import { Component, OnInit } from "@angular/core";
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: "app-bootstrapping",
  templateUrl: "bootstrapping.component.html"
})
export class BootstrappingComponent implements OnInit {

  counter = 0;
  opacityPercent = 100;
  sigVal = -1;

  constructor(private toastr: ToastrService) {}

  ngOnInit() {
    const thisObj = this;
    setInterval(function() {
      thisObj.opacityPercent = thisObj.opacityPercent + thisObj.sigVal * 3;
      if (thisObj.opacityPercent < 10) {
        thisObj.sigVal = +1;
      } else if (thisObj.opacityPercent > 100) {
        thisObj.sigVal = -1;
      }
      thisObj.counter++;
    }, 100);
  }
}
